/**
 * The dimension-core badge, exactly as the in-game menus draw it — the persona avatar at 9×9 pixels,
 * transcribed from `scripts/gui/guikit/palette.py` (`BADGE_ROWS`, `BADGE`). Inline SVG: no request, no
 * asset, and pixel-crisp at any whole-number scale, which is the in-game art's own rule ("never
 * resample, cut or redraw").
 */
const LINE = '#1d121e';
const BADGE: Readonly<Record<string, string>> = {
  o: LINE,
  k: LINE,
  '1': '#E39A7E',
  '2': '#C0694E',
  w: '#ffffff',
  s: '#D8D0EA',
  v: '#6B4FA0',
};
const BADGE_ROWS = ['...ooo...', '.oo111oo.', '.o12222o.', 'o122www2o', 'okkwvwkko', 'owwwwwwso', '.owwwwso.', '.oowssoo.', '...ooo...'];

export function PixelBadge({ scale = 3, className }: { readonly scale?: number; readonly className?: string }): React.JSX.Element {
  return (
    <svg className={className} width={9 * scale} height={9 * scale} viewBox="0 0 9 9" shapeRendering="crispEdges" aria-hidden="true" focusable="false">
      {BADGE_ROWS.flatMap((row, y) =>
        [...row].map((cell, x) => {
          const fill = BADGE[cell];
          return fill === undefined ? null : <rect key={`${x},${y}`} x={x} y={y} width={1} height={1} fill={fill} />;
        }),
      )}
    </svg>
  );
}
